import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import ContactUs from 'portal/src/components/support/ContactUs';
import FAQ from 'portal/src/components/support/FAQ';
import Page from 'portal/src/layouts/Page';

import { generatePageWithTabsRoute, RouteDefinition } from './routeGenerator';

const SupportPage = (props: React.ComponentProps<typeof Page>) => (
  <Page {...props} />
);

const routeDefinitions: RouteDefinition[] = [
  {
    element: <ContactUs />,
    name: 'Contact Us',
    path: NESTED_ROUTES.SUPPORT.CONTACT_US,
  },
  {
    element: <FAQ />,
    name: 'FAQ',
    path: NESTED_ROUTES.SUPPORT.FAQ,
  },
];

const SupportRoutes: RouteObject = generatePageWithTabsRoute(
  "We're here to help",
  BASE.SUPPORT,
  NESTED_ROUTES.SUPPORT.CONTACT_US,
  routeDefinitions,
  SupportPage,
);

export default SupportRoutes;
